export const ADVERTISERDISCLOSUREWRAPPER = 'AdvertiserDisclosureWrapper';
export const ARTICLEHEROWRAPPER = 'ArticleHeroWrapper';
export const AUTOINSURANCEMATCHES = 'AutoInsuranceMatches';
export const AWARDS2024BUTTONS = 'Awards2024Buttons';
export const AWARDSNAVIGATION = 'AwardsNavigation';
export const AWARDSBADGEDROPDOWN = 'AwardsBadgeDropdown';
export const BAINREFERRALBANNERSC = 'BainReferralBannerSC';
export const BACKTOTOP = 'BackToTop';
export const BORDERBANNER = 'BorderBanner';
export const CURRENTDATE = 'CurrentDate';
export const EDITORCONTROL = 'EditorControl';
export const FIXEDFIRSTCOLUMNTABLE = 'FixedFirstColumnTable';
export const FLEXCARDS = 'FlexCards';
export const FILTERS = 'Filters';
export const GLOBALNAV = 'GlobalNav';
export const GRID = 'Grid';
export const GRIDFORM = 'GridForm';
export const HORIZONTALBANNER = 'HorizontalBanner';
export const INPUTBUTTON = 'InputButton';
export const INSURANCESUMMARYTABLEWRAPPER = 'InsuranceSummaryTableWrapper';
export const INSURANCEPRODUCTCARDWRAPPER = 'InsuranceProductCardWrapper';
export const KETOPRODUCTCARD = 'KetoProductCard';
export const LOTTIEANIMATION = 'LottieAnimation';
export const MULTILEVELFILTERS = 'MultilevelFilters';
export const PAGE = 'Page';
export const RETIREMENTCALCULATORSC = 'RetirementCalculatorSC';
export const DYNAMICGRID = 'DynamicGrid';
export const STICKYHEADER = 'StickyHeaderV2';
export const THIRDPARTYEMBED = 'ThirdPartyEmbedV2';
export const OURVALUES = 'OurValues';
export const UNIVERSALACCORDION = 'UniversalAccordion';
export const UNIVERSALBULLETLIST = 'UniversalBulletList';
export const UNIVERSALBUTTON = 'UniversalButton';
export const UNIVERSALCONTAINER = 'UniversalContainer';
